import React, { Component } from 'react';
// import './App.css';
import instance from "./axios-instance";
import SweetAlert from 'react-bootstrap-sweetalert';
import jwt_decode from "jwt-decode";
//import './style.css';
import NavMenu from './navmenu';
import Systems from "./SystemFunction";
import Banner from './banner';
import MoblieMenu from "./mobilemenu";
import TextSlider from './textslide';
import axios from 'axios';
import Swal from 'sweetalert2'
import moment from 'moment';
class App extends Component {
  constructor(props) {
    super(props)
    this.state = {
      prettylist: []
    }

  }

  async componentDidMount() {
    this.link = document.createElement('link');
    this.link.rel = 'stylesheet';
    this.link.href = './ulive.css'; // Path to your CSS
    document.head.appendChild(this.link);

    const res = await axios.post("https://api.upretty.live/public/pretty/list/explore", {
      page: 1,
    });
    console.log(res.data);
    this.setState({
      prettylist: res.data.rows
    });

  }

  clickopen = async (id) => {
    // เปิดแท็บทันที กันโดน popup blocker
    const newTab = window.open('', '_blank');

    try {
      if (!id) throw new Error('missing stream id');
      const res = await axios.post(
        "https://apipretty.newworld.center/pretylive/get-playback-url",
        {
          id: id
        }
      );

      // ถ้าโดน auth/cors/policy
      if (res.status === 401) throw new Error('Unauthorized (401) - token หมดอายุ/ไม่ถูกต้อง');
      if (res.status === 403) throw new Error('Forbidden (403) - ถูกบล็อกสิทธิ์/Origin policy');
      if (res.status < 200 || res.status >= 300) {
        throw new Error(`HTTP ${res.status}: ${JSON.stringify(res.data)}`);
      }

      console.log("playback url:", href, id);

      // ดึง url แบบปลอดภัย
      let href = res.data?.playbackUrl || res.data?.url;

      // บางที playbackUrl อาจเป็น object/array
      if (href && typeof href === 'object') {
        href = href?.url || href?.playbackUrl || href?.[0]?.url || href?.[0]?.playbackUrl;
      }

      if (!href || typeof href !== 'string') {
        throw new Error('ยังไม่มีการไลฟ์สด (no playback url)');
      }

      // ถ้าเปิดแท็บไว้แล้ว ให้ redirect ไป url
      if (newTab) {
        newTab.location.href = href;
        newTab.focus();
      } else {
        // ถ้าโดนบล็อกจริง ๆ ค่อย fallback
        window.location.href = href;
      }
    } catch (err) {
      console.error(err);

      // ปิดแท็บที่เปิดไว้ ถ้าเปิดสำเร็จแต่เกิด error
      if (newTab && !newTab.closed) newTab.close();

      // แสดง error แบบอ่านรู้เรื่อง
      const msg =
        err?.response?.data?.message ||
        err?.message ||
        'ยังไม่มีการไลฟ์สด หรือเซิร์ฟเวอร์ตอบกลับผิดพลาด';

      Swal.fire('ไม่สามารถดำเนินการได้', msg, 'error');
    }
  };




  render() {
    const { prettylist } = this.state;
    const hasLive = prettylist.some(
      (item) => item?.livestream?.isLive === true
    );
    return (
      <>
        <div className="rounded bg-[#c4974d] text-white w-full py-2 px-5 my-2">
          <h3>กำลัง Live</h3>
        </div>
        <div className="bg-gray-900 w-full p-6">
          <h3 className="text-center text-white">
            {" "}
            {!hasLive && (
              <div className="no-live">
                ไม่มีรายการที่กำลังไลฟ์สดในขณะนี้
              </div>
            )}
            {prettylist.map((item, index) => (item.livestream.isLive ? <a role="button" onClick={(e) => { this.clickopen(item.livestream._id) }}>
              <div className="flex basis-1/2 px-1 mb-2">
                <div className="flex w-full pt-[100%] relative">
                  <div
                    className="flex absolute w-full h-full top-0 left-0 bg-cover bg-center cursor-pointer rounded-lg overflow-hidden"
                    style={{
                      backgroundImage:
                        'url("' + item.profileImageUrl + '")',
                    }}
                  >
                    <div className="flex flex-col justify-between h-full w-full bg-[linear-gradient(180deg,rgba(19,19,21,0)_50%,rgba(19,19,21,1)_100%)]">
                      <div className="flex justify-between p-2">
                        <div className="flex flex-1">
                          <div className="flex flex-1">{/**/}</div>
                        </div>
                        <div className="flex items-center px-2 py-1 rounded bg-[linear-gradient(270deg,rgba(19,19,21,0.4)_0%,rgba(19,19,21,0.00)_104.29%)]">
                          <img
                            src="data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20viewBox='0%200%206.23%209'%20fill='none'%3e%3cpath%20d='M6.23828%205.07061C6.23828%206.7905%204.83904%208.18975%203.11914%208.18975C1.39925%208.18975%200%206.7905%200%205.07061C0%204.39745%200.2316%203.73721%200.652124%203.21157L0.692417%203.1612C0.767437%203.06743%200.900232%203.04357%201.0032%203.10534L1.47598%203.38901C1.61239%203.47084%201.72528%203.3951%201.75665%203.36994C1.78802%203.34478%201.88646%203.25096%201.83615%203.10006L1.82604%203.0697C1.66722%202.59327%201.72879%202.07575%201.99499%201.64989C2.25951%201.22663%202.39934%200.739064%202.39934%200.239938V0.240193C2.39934%200.0656336%202.57983%20-0.0504944%202.7387%200.0218536L2.73872%200.0218696V0.0215817C2.75475%200.0288917%203.13651%200.204043%203.59431%200.524067C4.14812%200.911209%204.47877%201.54587%204.47877%202.22174C4.47877%202.35919%204.55308%202.47606%204.67756%202.53436C4.80201%202.59265%204.93936%202.57494%205.04498%202.48693C5.15469%202.3955%205.31951%202.41958%205.39848%202.53858C5.94003%203.35466%206.23828%204.25389%206.23828%205.07061Z'%20fill='url(%23paint0_linear_2_1092)'/%3e%3cpath%20d='M4.23888%204.35077C4.41442%204.35077%204.53055%204.5331%204.45631%204.69216L3.33662%207.0915C3.23407%207.31123%202.90751%207.25754%202.88073%207.01653L2.74448%205.79037H1.9995C1.82397%205.79037%201.70784%205.60804%201.78207%205.44898L2.90176%203.04964C3.00431%202.82991%203.33088%202.88361%203.35766%203.12461L3.49391%204.35077H4.23888Z'%20fill='url(%23paint1_linear_2_1092)'/%3e%3cdefs%3e%3clinearGradient%20id='paint0_linear_2_1092'%20x1='3.11914'%20y1='8.18975'%20x2='3.11914'%20y2='-5.85777e-06'%20gradientUnits='userSpaceOnUse'%3e%3cstop%20stop-color='%23FD5900'/%3e%3cstop%20offset='1'%20stop-color='%23FFDE00'/%3e%3c/linearGradient%3e%3clinearGradient%20id='paint1_linear_2_1092'%20x1='3.11919'%20y1='2.91101'%20x2='3.11919'%20y2='7.23013'%20gradientUnits='userSpaceOnUse'%3e%3cstop%20stop-color='%23FFEFC2'/%3e%3cstop%20offset='1'%20stop-color='%23F7DA87'/%3e%3c/linearGradient%3e%3c/defs%3e%3c/svg%3e"
                            alt=""
                            className="h-3 w-2 object-cover mr-1"
                          />
                          <div className="text-[#F6D780] text-xs md:text-lg font-medium">
                            {item.livestream.viewerCount}
                          </div>
                        </div>
                      </div>
                      <div className="flex flex-col w-full text-white text-xs font-medium p-2">
                        <div className="flex flex-1 mb--3">
                          <div className="flex h-5 items-center">
                            <div className="text-[12px] sm:text-lg md:text-2xl md:font-bold whitespace-nowrap font-bold">
                              {moment(item.liveDateTimeStart).format('HH:mm') + " - " + moment(item.liveDateTimeEnd).format('HH:mm') + (item.liveDateTimeEnd ? " (Offline)" : item.displayName)}
                            </div>
                          </div>
                        </div>
                        <div className="flex flex-row w-full">
                          <div
                            className="flex sm:hidden flex-grow leading-normal font-bold gold"
                            style={{ fontSize: 14 }}
                          >
                            {item.livestream.isLive ? "วาซาบิ ถอดหมด 🔒" : "วาซาบิ กำลังถ่ายอยู่ 🎥"}
                          </div>
                          <div
                            className="hidden sm:flex flex-grow leading-normal font-bold gold"
                            style={{ fontSize: 30 }}
                          >
                            {item.displayName}
                          </div>
                          {/**/}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </a> : " "))}

          </h3>
        </div>

        <div className="grid grid-cols-2">

          {prettylist.map((item, index) => (item.livestream.isLive ? " " :
            <a role="button" onClick={(e) => { this.clickopen(item.livestream._id) }}>
              <div className="flex basis-1/2 px-1 mb-2">
                <div className="flex w-full pt-[100%] relative">
                  <div
                    className="flex absolute w-full h-full top-0 left-0 bg-cover bg-center cursor-pointer rounded-lg overflow-hidden"
                    style={{
                      backgroundImage:
                        'url("' + item.profileImageUrl + '")',
                    }}
                  >
                    <div className="flex flex-col justify-between h-full w-full bg-[linear-gradient(180deg,rgba(19,19,21,0)_50%,rgba(19,19,21,1)_100%)]">
                      <div className="flex justify-between p-2">
                        <div className="flex flex-1">
                          <div className="flex flex-1">{/**/}</div>
                        </div>
                        <div className="flex items-center px-2 py-1 rounded bg-[linear-gradient(270deg,rgba(19,19,21,0.4)_0%,rgba(19,19,21,0.00)_104.29%)]">
                          <img
                            src="data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20viewBox='0%200%206.23%209'%20fill='none'%3e%3cpath%20d='M6.23828%205.07061C6.23828%206.7905%204.83904%208.18975%203.11914%208.18975C1.39925%208.18975%200%206.7905%200%205.07061C0%204.39745%200.2316%203.73721%200.652124%203.21157L0.692417%203.1612C0.767437%203.06743%200.900232%203.04357%201.0032%203.10534L1.47598%203.38901C1.61239%203.47084%201.72528%203.3951%201.75665%203.36994C1.78802%203.34478%201.88646%203.25096%201.83615%203.10006L1.82604%203.0697C1.66722%202.59327%201.72879%202.07575%201.99499%201.64989C2.25951%201.22663%202.39934%200.739064%202.39934%200.239938V0.240193C2.39934%200.0656336%202.57983%20-0.0504944%202.7387%200.0218536L2.73872%200.0218696V0.0215817C2.75475%200.0288917%203.13651%200.204043%203.59431%200.524067C4.14812%200.911209%204.47877%201.54587%204.47877%202.22174C4.47877%202.35919%204.55308%202.47606%204.67756%202.53436C4.80201%202.59265%204.93936%202.57494%205.04498%202.48693C5.15469%202.3955%205.31951%202.41958%205.39848%202.53858C5.94003%203.35466%206.23828%204.25389%206.23828%205.07061Z'%20fill='url(%23paint0_linear_2_1092)'/%3e%3cpath%20d='M4.23888%204.35077C4.41442%204.35077%204.53055%204.5331%204.45631%204.69216L3.33662%207.0915C3.23407%207.31123%202.90751%207.25754%202.88073%207.01653L2.74448%205.79037H1.9995C1.82397%205.79037%201.70784%205.60804%201.78207%205.44898L2.90176%203.04964C3.00431%202.82991%203.33088%202.88361%203.35766%203.12461L3.49391%204.35077H4.23888Z'%20fill='url(%23paint1_linear_2_1092)'/%3e%3cdefs%3e%3clinearGradient%20id='paint0_linear_2_1092'%20x1='3.11914'%20y1='8.18975'%20x2='3.11914'%20y2='-5.85777e-06'%20gradientUnits='userSpaceOnUse'%3e%3cstop%20stop-color='%23FD5900'/%3e%3cstop%20offset='1'%20stop-color='%23FFDE00'/%3e%3c/linearGradient%3e%3clinearGradient%20id='paint1_linear_2_1092'%20x1='3.11919'%20y1='2.91101'%20x2='3.11919'%20y2='7.23013'%20gradientUnits='userSpaceOnUse'%3e%3cstop%20stop-color='%23FFEFC2'/%3e%3cstop%20offset='1'%20stop-color='%23F7DA87'/%3e%3c/linearGradient%3e%3c/defs%3e%3c/svg%3e"
                            alt=""
                            className="h-3 w-2 object-cover mr-1"
                          />
                          <div className="text-[#F6D780] text-xs md:text-lg font-medium">
                            {item.livestream.viewerCount}
                          </div>
                        </div>
                      </div>
                      <div className="flex flex-col w-full text-white text-xs font-medium p-2">
                        <div className="flex flex-1 mb--3">
                          <div className="flex h-5 items-center">
                            <div className="text-[12px] sm:text-lg md:text-2xl md:font-bold whitespace-nowrap font-bold">
                              {moment(item.liveDateTimeStart).format('HH:mm') + " - " + moment(item.liveDateTimeEnd).format('HH:mm') + (item.liveDateTimeEnd ? " (Offline)" : item.displayName)}
                            </div>
                          </div>
                        </div>
                        <div className="flex flex-row w-full">
                          <div
                            className="flex sm:hidden flex-grow leading-normal font-bold gold"
                            style={{ fontSize: 14 }}
                          >
                            {item.livestream.isLive ? "วาซาบิ ถอดหมด 🔒" : "วาซาบิ กำลังถ่ายอยู่ 🎥"}
                          </div>
                          <div
                            className="hidden sm:flex flex-grow leading-normal font-bold gold"
                            style={{ fontSize: 30 }}
                          >
                            {item.displayName}
                          </div>
                          {/**/}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </a>
          ))}
        </div >

      </>


    );
  }
}
export default App;
